import Swal from 'sweetalert2';
import React, { memo, useEffect } from 'react';
import { GridBase } from '../../components';
import strings from '../../globalization';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  catSoftwareVersionList,
  catSoftwareVersionFormReset
} from '../../redux/actions';
import { faTimes, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import consts from '../../consts';

const deleteFailedString = 'DeleteFailed';

const Default = ({ row }) => {
  const { IsDefault, id } = row;
  return (
    <div
      key={id}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}
    >
      {IsDefault ? (
        <FontAwesomeIcon
          icon={faCheckCircle}
          style={{ color: 'green', fontSize: '20px' }}
        />
      ) : (
        <FontAwesomeIcon
          icon={faTimes}
          style={{ color: 'red', fontSize: '20px' }}
        />
      )}
    </div>
  );
};
const CATSoftwareVersion = memo(props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { CustomError: customError, err } = useSelector(state => {
    return state.catSoftwareVersionFormData.data;
  });
  const loginData = useSelector(state => {
    const { userDetail } = state.loginData.data || {};
    return userDetail;
  }, shallowEqual);
  const showHideAddButton =
    loginData && consts.UserRoleId.SuperAdmin.includes(loginData.UserRole);
  useEffect(() => {
    if (customError && err === deleteFailedString) {
      Swal.fire({
        title: strings[err],
        text: strings.CATSoftwareVersionLinkedToLicense,
        icon: 'warning'
      });
      dispatch(catSoftwareVersionFormReset());
    }
  }, [customError, err]);
  const handleAdd = () =>
    history.push({
      pathname: `/catsoftwareversion/new/`
    });
  const columns = [
    {
      key: 'CATSoftwareVersion',
      name: strings.CatSoftwareVersion,
      width: 250,
      type: 'text',
      displayValue: 'CATSoftwareVersion',
      cellClass: 'cell-center',
      headerCellClass: 'cell-center'
    },
    {
      key: 'IsDefault',
      name: strings.Default,
      filterable: false,
      getRowMetaData: row => row,
      formatter: Default,
      width: 150,
      cellClass: 'cell-center',
      headerCellClass: 'cell-center'
    }
  ];
  return (
    <GridBase
      {...props}
      columns={columns}
      key={Math.random()}
      title={strings.CatSoftwareVersion}
      handleAdd={handleAdd}
      action={catSoftwareVersionList}
      detailRoute="CATSoftwareVersion"
      dataProperty="catSoftwareVersionListData"
      sortColumn={'CATSoftwareVersion'}
      sortOrder={true}
      listId="CATSoftwareVersion"
      loadPref={true}
      baseFilter={{ search: '' }}
      showAddButton={showHideAddButton}
    />
  );
});
export default CATSoftwareVersion;
